import React from 'react'
import Notes from './notes-table'
import '../../../../../css/timeline.sass'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showAddNoteModal } from '../../../actions/profile'
import Button from '../../../../../components/button'
import styled from 'styled-components';

const AddButton = styled(Button)`
  margin: 0 0 0 24px;
`;

const NotesPage = (props) => {
  const account = props.account
  const setUpdateNotes = props.setUpdateNotes

  return (
    <div className='inspect-page-container'>
      <p style={{ marginBottom: '25px', textAlign: 'center'}}><span style={{ fontWeight: 'bold'}}>{account.user.full_name} ({account.user.email_address})</span></p>
      <div className='table-head-wrapper' style={{justifyContent: 'space-between'}}>
        <h2>Trainer Notes</h2>
        <AddButton 
          label="Add New Note"
          onClick={() => props.showAddNoteModal(true)}
        />
      </div>
      <Notes userId={props.userId} account={account} setUpdateNotes={setUpdateNotes} />
    </div>
  )
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAddNoteModal }, dispatch)
}

export default connect(null, mapDispatchToProps)(NotesPage)
